<!-- event-services-entity.component.html -->
<app-entity-mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle title="Services"></app-entity-mat-dialog-title>

<div [ngClass]="{
        'loading-shade': showProgressSpinner
     }">

    <div mat-dialog-content>

        <mat-progress-spinner class="matProgressSpinnerCentered" *ngIf="showProgressSpinner" mode="indeterminate">
        </mat-progress-spinner>

        <mat-tab-group class="eventTabGroup" [(selectedIndex)]="this.selectedIndex" (selectedTabChange)="setFormMode($event.index)"
            animationDuration="0ms" #tabs>

            <mat-tab label="View" [disabled]="this.initActionType == 'create'">
                <app-entity-mat-tab-view [entityData]="entityData"></app-entity-mat-tab-view>
            </mat-tab>

            <mat-tab label="{{(this.initActionType == 'create' ? 'Create' : 'Edit')}}">
                <app-error-message [message]=this.errorMessage></app-error-message>

                <!-- Form -->
                <form (ngSubmit)="onSubmit(f)" #f="ngForm" class="form">
                    <div class="container">
                        <div class="row">

                            <div class="col-6">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Service Type</mat-label>
                                    <mat-select matInput ngModel name="field_type" required (selectionChange)="updateLessonDefaultTimes($event.value, 'service')">
                                        <mat-option *ngFor="let element of sortedServiceTypes"
                                            [value]="element.id">{{ element.name }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>


                            <div class="col-6">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Executive</mat-label>
                                    <mat-select required [(ngModel)]="field_executive" name="field_executive">
                                      <mat-option>None</mat-option>
                                      <ng-container *ngFor="let element of _fieldsService.instructorsExecutive(); let i = index">
                                        <mat-option *ngIf="element.status !== '0' || (element.status === '0' && element.uid === field_executive)"
                                                    [value]="element.uid">
                                          {{ element.value }}
                                          <ng-container *ngIf="element.status === '0' && element.uid === field_executive"></ng-container>
                                        </mat-option>
                                      </ng-container>
                                      <!-- Web-booking pre-chats start on the Website Booking service account; shown so the field is not blank until an executive is picked. -->
                                      <ng-container *ngFor="let element of _fieldsService.systemUsers()">
                                        <mat-option *ngIf="element.uid === field_executive" [value]="element.uid">{{ element.value }}</mat-option>
                                      </ng-container>
                                    </mat-select>
                                  </mat-form-field>
                            </div>


                            <div class="col-6">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Duration</mat-label>
                                    <mat-select matInput ngModel name="field_duration">
                                        <mat-option>None</mat-option>
                                        <mat-option *ngFor="let element of this._fieldsService.durations"
                                            [value]="element.value">
                                            {{ element.value }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-6">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Choose a date</mat-label>
                                    <input [(ngModel)]="field_date_and_time"
                                           name="field_date_and_time"
                                           matInput
                                           type="text"
                                           appFlatpickrDatetime
                                           [enableTime]="true"
                                           [minuteIncrement]="15"
                                           [setCurrentTimeOnOpen]="true"
                                           [closeOnSelect]="false"
                                           (ngModelChange)="handleDateTimeChange($event)"
                                           required
                                           readonly>
                                    <mat-icon matSuffix>calendar_today</mat-icon>
                                </mat-form-field>
                            </div>


                            <div class="col-12 mt-1">
                                <mat-expansion-panel [disabled]="true" [expanded]="true">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            Personal Information
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <input
                                        class="d-none"
                                        type="text"
                                        [(ngModel)]="field_student"
                                        name="field_student"
                                        value="{{studentList}}">

                                    <!-- Attendees -->
                                    <app-display-attendees
                                    [field_students]="field_student"
                                    [studentUpdateLoad]="studentUpdateLoad"
                                    [studentRemove]="studentRemove"></app-display-attendees>

                                    <div
                                    [ngClass]="{ 'd-none': (this.objLength(field_student) > 0) && !this.editMode }"
                                    style="padding: 0 12px; margin-bottom: 12px;"
                                    ngModelGroup="__field_students_inline_form"
                                    #attendee="ngModelGroup"
                                    >

                                        <input class="d-none" ngModel name="id" matInput>
                                        <input class="d-none" [ngModel]="entityType" name="type" matInput>
                                        <input class="d-none" [ngModel]="entityBundle" name="bundle" matInput>

                                        <div class="row">
                                            <!-- Student Account Autocomplete -->
                                            <div class="col-12">
                                                <mat-form-field class="full-width-field">
                                                    <mat-label>Student Account</mat-label>
                                                    <input
                                                        required
                                                        name="field_student_account"
                                                        (input)="onAutocompleteStudent($event)"
                                                        matInput
                                                        (ngModelChange)="onStudentNameSelectThenLoadEnrollmentName($event, true); lookupStudentAccountContact({option: {value: $event}}, false, 'service');"
                                                        [ngModel]="''"
                                                        #td_student_account
                                                        [matAutocomplete]="autoCompleteStudentAccount"
                                                        >
                                                    <button type="button" matSuffix mat-icon-button
                                                        aria-label="manage_accounts">
                                                        <mat-icon>manage_accounts</mat-icon>
                                                    </button>
                                                </mat-form-field>
                                                <mat-autocomplete
                                                    #autoCompleteStudentAccount="matAutocomplete"
                                                    (optionSelected)="lookupStudentAccountContact($event, false, 'service'); onStudentNameSelectThenLoadEnrollmentName($event);"
                                                    >
                                                    <mat-option
                                                        *ngFor="let option of autoCompleteStudentOptions"
                                                        [value]="option.label + ' (' + option.value + ')'">
                                                        {{option.label}} ({{option.value}})
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </div>

                                            <div
                                            class="col-12 mb-3">
                                                <label
                                                    [ngClass]="{ 'd-none': !(this.objLength(autoCompleteStudentContactOptions) > 0) }"
                                                >Students<sup>*</sup></label>
                                                <mat-radio-group
                                                    ngModel
                                                    name="field_students"
                                                    class="radio-group"
                                                    aria-label="Select an option"
                                                    required>
                                                    <mat-radio-button
                                                    class="col-12 radio-button"
                                                    *ngFor="let contact of autoCompleteStudentContactOptions"
                                                    [value]="contact['id']">
                                                        {{ contact['title'] }}
                                                        <!-- {{ contact['id'] }} -->
                                                    </mat-radio-button>
                                                </mat-radio-group>
                                            </div>

                                            <!-- <div class="col-6">
                                                <mat-form-field class="full-width-field">
                                                    <mat-label>Student (Contact)</mat-label>
                                                    <input
                                                        name="field_students_contact"
                                                        (input)="onAutocompleteStudentContact($event)"
                                                        matInput
                                                        ngModel
                                                        [matAutocomplete]="autoCompleteStudentContact"
                                                        >
                                                    <button type="button" matSuffix mat-icon-button
                                                        aria-label="manage_accounts">
                                                        <mat-icon>manage_accounts</mat-icon>
                                                    </button>
                                                </mat-form-field>
                                                <mat-autocomplete #autoCompleteStudentContact="matAutocomplete">
                                                    <mat-option
                                                        *ngFor="let option of autoCompleteStudentContactOptions"
                                                        [value]="option.label + ' (' + option.value + ')'">
                                                        {{option.label}} ({{option.value}})
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </div> -->

                                            <!-- Enrollment Dropdown -->
                                            <!-- <div class="col-12">
                                                <mat-form-field
                                                    class="full-width-field">
                                                    <mat-label>Enrollment Name</mat-label>
                                                    <mat-select
                                                        required
                                                        matInput
                                                        ngModel
                                                        name="field_enrollment"
                                                        (selectionChange)="validateEnrollment('_none', td_student_account.value, enrollment_id.value)"
                                                        #enrollment_id
                                                        >
                                                        <mat-option>None</mat-option>
                                                        <mat-option
                                                            *ngFor="let element of enrollmentsForUser"
                                                            [value]="element[0].toString()">
                                                            {{ element[1] }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div> -->

                                            <!-- <p *ngIf="enrollmentMessage">{{enrollmentMessage}}</p> -->

                                            <!-- <div class="col-12">
                                                <mat-form-field
                                                    class="full-width-field">
                                                    <mat-label>Description</mat-label>
                                                    <textarea
                                                        name="field_description"
                                                        ngModel
                                                        matInput
                                                        placeholder=""></textarea>
                                                </mat-form-field>
                                            </div> -->
                                        </div>
                                        <div class="col-12">
                                            <button *ngIf="!editMode" type="button"
                                                mat-raised-button
                                                [disabled]="!attendee.valid"
                                                class="me-1"
                                                color="primary" (click)="studentIncrement(attendee.value)">
                                                Create attendees
                                            </button>
                                            <button *ngIf="editMode" type="button"
                                                mat-raised-button
                                                [disabled]="!attendee.valid"
                                                class="me-1"
                                                color="primary" (click)="studentUpdateSubmit(i, attendee.value)">
                                                Edit Attendee
                                            </button>
                                        </div>

                                    </div>
                                </mat-expansion-panel>
                            </div>



                            <div class="col-12" *ngIf="this.actionType === 'create'">
                                <app-standing-series
                                  [studentAccountId]="extractIdFromAutocomplete(field_student?.[0]?.field_student_account || '')"
                                  [instructorId]="field_executive || ''"
                                  [duration]="f?.value?.field_duration || '00:45'"
                                  [time]="field_date_and_time ? (field_date_and_time | date:'HH:mm') : ''"
                                  [startDate]="field_date_and_time ? (field_date_and_time | date:'yyyy-MM-dd') : ''"
                                  [lessonType]="f?.value?.field_type || ''"
                                  [bundle]="'services'"
                                  [selectedEnrollment]="null"
                                  [supportsEnrollment]="false"
                                  (recurrenceChanged)="onRecurrenceChanged($event)">
                                </app-standing-series>
                            </div>

                            <div class="col-12">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Notes</mat-label>
                                    <textarea ngModel name="field_notes" matInput placeholder=""></textarea>
                                </mat-form-field>
                            </div>

                            <div>
                                <mat-form-field class="full-width-field">
                                    <mat-label>Status</mat-label>
                                    <mat-select required ngModel name="field_status">
                                        <mat-option>None</mat-option>
                                        <mat-option *ngFor="let element of this._taxonomyService.service_status"
                                            [value]="element.id">{{ element.name }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                        </div>
                    </div>
                </form>
            </mat-tab>

            <mat-tab label="Delete" [disabled]="this.initActionType == 'create'">
                <app-entity-confirm-delete></app-entity-confirm-delete>
            </mat-tab>

        </mat-tab-group>

    </div>

</div>

<!-- Add this debugging section above mat-dialog-actions -->
<!-- <div style="margin: 10px; padding: 10px; background: #f5f5f5;" *ngIf="f">
    <p>Form Valid: {{f.valid}}</p>
    <p>Form Values: {{f.value | json}}</p>
    <p>Form Errors: {{f.errors | json}}</p>
    <p>Form Controls with Errors:</p>
    <ul>
        <li *ngFor="let control of f.controls | keyvalue">
            {{control.key}}: {{control.value.errors | json}}
        </li>
    </ul>
</div> -->

<mat-dialog-actions align="end">
    <ng-container *ngIf="this.actionType === 'create'">
        <button type="button"
                [disabled]="isSaving || !isFormValid() || (isRecurring && (!recurrenceConfig || recurrenceConfig.days.length === 0))"
                (click)="onSubmit(f);"
                mat-raised-button
                color="primary">{{ isRecurring
                                     ? (isSaving ? 'Generating...' : 'Save & Generate Series')
                                     : (isSaving ? 'Saving...' : 'Save') }}</button>
    </ng-container>

    <!-- Conflict display for recurring save -->
    <div *ngIf="seriesConflicts?.length > 0" class="series-conflict-section" style="width: 100%; padding: 12px 0;">
        <div style="display: flex; align-items: center; gap: 8px; color: #c62828; margin-bottom: 8px;">
            <mat-icon>warning</mat-icon>
            <strong>{{ seriesConflicts.length }} conflict(s) found</strong>
        </div>
        <div style="max-height: 120px; overflow-y: auto; margin-bottom: 8px;">
            <div *ngFor="let c of seriesConflicts" style="font-size: 0.9em; padding: 2px 0; color: #555;">
                {{ c.date | date:'EEE, MMM d' }} &mdash; {{ c.message }}
            </div>
        </div>
        <div style="display: flex; gap: 8px;">
            <button mat-raised-button color="warn" [disabled]="isSaving"
                    (click)="generateIgnoringConflicts()">
                Generate Anyway
            </button>
            <button mat-raised-button [disabled]="isSaving"
                    (click)="cancelRecurringSave()">
                Cancel
            </button>
        </div>
    </div>
    <ng-container *ngIf="this.actionType === 'edit'">
        <ng-container *ngIf="this.initActionType == 'edit'">
            <button type="button"
                    [disabled]="isSaving"
                    (click)="setFormMode('delete')"
                    mat-raised-button
                    color="accent">Delete</button>
            <button type="button"
                    [disabled]="isSaving || !isFormValid()"
                    (click)="onSubmit(f);"
                    mat-raised-button
                    color="primary">{{ isSaving ? 'Saving...' : 'Save' }}</button>
        </ng-container>
        <ng-container *ngIf="this.initActionType == 'create'">
            <button type="button"
                    (click)="closeDialog()"
                    mat-raised-button
                    color="accent">Cancel</button>
            <button type="button"
                    [disabled]="isSaving || !isFormValid()"
                    (click)="onSubmit(f);"
                    mat-raised-button
                    color="primary">{{ isSaving ? 'Saving...' : 'Save' }}</button>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="this.actionType === 'delete'">
        <button (click)="setFormMode('edit')"
                type="submit"
                mat-raised-button
                color="accent">Cancel</button>
        <button (click)="onDeleteSubmit(this._injectedDialogData['data']['EntityID'])"
                type="submit"
                mat-raised-button
                color="accent">Delete</button>
    </ng-container>
</mat-dialog-actions>
